function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { createMediaQueries } from '../styles/style-helpers';
var purple = {
  purple40: '#7229E6',
  purple30: '#863BFF',
  purple20: '#C099FF',
  purple10: '#EEE3FF'
};
var shades = {
  shade80: '#262930',
  shade70: '#4A4F58',
  shade60: '#727780',
  shade50: '#ABB0BA',
  shade40: '#CFD2D9',
  shade30: '#E5E7EB',
  shade20: '#F0F1F2',
  shade10: '#FAFAFB'
};
var red = {
  red40: '#D40728',
  red30: '#FF4D6A',
  red20: '#FFBDC8',
  red10: '#FFE3E8'
};
var honey = {
  honey40: '#916B00',
  honey30: '#FFC938',
  honey20: '#FFE7A7',
  honey10: '#FFF8E3'
};
var mint = {
  mint40: '#008262',
  mint30: '#28D2A7',
  mint20: '#A6EDDB',
  mint10: '#DEFAF3'
};
var cyan = {
  cyan40: '#0075B0',
  cyan30: '#49B9F2',
  cyan20: '#B4E3FB',
  cyan10: '#E3F6FF'
};
var white = '#FFFFFF';
var black = '#000000';
var brand = {
  brand10: purple.purple10,
  brand20: purple.purple20,
  brand30: purple.purple30,
  brand40: purple.purple40
};
var accent = {
  accent40: '#C95100',
  accent30: '#FF6600',
  accent20: '#FFB380',
  accent10: '#FFE9DB'
};
var special = {
  magenta40: '#D1008B',
  magenta30: '#FD38BA',
  magenta20: '#FFADE4',
  magenta10: '#FFE3F6'
};
var magenta = {
  special40: '#D1008B',
  special30: '#FD38BA',
  special20: '#FFADE4',
  special10: '#FFE3F6'
};
export var breakpoints = {
  mobile: '(max-width: 767px)',
  mobileLandscape: '(min-width: 480px) and (max-width: 767px) and (orientation: landscape)',
  tablet: '(min-width: 768px) and (max-width: 1279px)',
  desktop: '(min-width: 1280px)'
};
export var mq = createMediaQueries(breakpoints);
export var spacings = {
  xxxSmall: '8px',
  xxSmall: '16px',
  xSmall: '24px',
  small: '32px',
  medium: '40px',
  large: '48px',
  xLarge: '64px',
  xxLarge: '80px'
};
export var colors = _extends({}, shades, purple, red, honey, mint, cyan, brand, accent, special, magenta, {
  white: white,
  black: black
});
export var shapes = {
  shapes0: '0px',
  shapes2: '2px',
  shapes4: '4px',
  shapes8: '8px',
  shapes16: '16px',
  shapes24: '24px',
  shapes100: '100%',
  shapes240: '240px'
};
var exportShadows = function exportShadows(color) {
  /* eslint-disable */
  var small = "0 1px 0 0 " + color + "0D, 0 2px 4px 0 " + color + "0D, 0 4px 8px 0 " + color + "0D";
  /* eslint-enable */
  var medium = "0 8px 16px 0 " + color + "0D, 0 12px 24px 0 " + color + "0D";
  return {
    small: small,
    medium: small + ", " + medium,
    large: small + ", " + medium + ", 0 16px 32px 0 " + color + "0D",
    xSmall: "0 2px 0 0 " + color + "1A",
    xSmallTop: "0 -2px 0 0 " + color + "1A",
    xSmallLeft: "-2px 0 0 0 " + color + "1A",
    xSmallRight: "2px 0 0 0 " + color + "1A"
  };
};
export var shadows = {
  "default": exportShadows(shades.shade60),
  informative: exportShadows(cyan.cyan40),
  attention: exportShadows(honey.honey40),
  negative: exportShadows(red.red40),
  positive: exportShadows(mint.mint40),
  highlight: exportShadows(brand.brand40),
  accent: exportShadows(accent.accent40),
  border: exportShadows
};

// old, TODO, validar e remover daqui pra baixo no futuro
export var iconsSizes = {
  base: {
    16: {
      big: {
        size: '64px'
      },
      normal: {
        size: '32px'
      },
      small: {
        size: '16px'
      }
    },
    12: {
      big: {
        size: '48px'
      },
      normal: {
        size: '24px'
      },
      small: {
        size: '12px'
      }
    }
  }
};
export var typography = {
  fontWeight: {
    bold: 700,
    regular: 400
  },
  text: {
    big: {
      fontsize: '16px',
      lineHeight: '24px'
    },
    normal: {
      fontsize: '14px',
      lineHeight: '20px'
    },
    small: {
      fontsize: '12px',
      lineHeight: '18px'
    }
  },
  heading: {
    big: {
      fontsize: '30px',
      lineHeight: '36px'
    },
    normal: {
      fontsize: '25px',
      lineHeight: '30px'
    },
    small: {
      fontsize: '20px',
      lineHeight: '26px'
    }
  }
};
export var widths = {
  drawers: '400px',
  navBar: '320px',
  navBarSubItem: '288px',
  navBarItemLabel: '216px',
  navBarCollapsed: '64px',
  mobileCollapseButton: '32px'
};
export var heights = {
  utilityNav: '64px',
  mobileCollapseButton: '32px'
};
export var zIndex = {
  // Não setar um valor maior que 21, em lugar nenhum
  mask: 20,
  contentMask: 21,
  toastContainer: 19,
  inputStyle: 1,
  inputIcon: 2,
  footer: 3
};